import { useState, useEffect } from "react";
// import Trans from "next-translate/Trans";
import useTranslation from "next-translate/useTranslation";
import styles from '../Reciter/RecitersList.module.scss';
import Image from "next/image";

import ImgsViewer from "react-images-viewer";
import NextSeoWrapper from "@/components/NextSeoWrapper";
import PageContainer from "@/components/PageContainer";
import { getLanguageAlternates } from "@/utils/locale";
import { getCanonicalUrl } from "@/utils/navigation";
import { makeCDNImagesUrl } from "@/utils/cdn";

const path = "/posts";

const MediaPage = () => {
    const { lang } = useTranslation("mediaPost");

    // ✅ replace class state with hooks
    const [currImg, setCurrImg] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);
    const [images, setImages] = useState<string[]>([]);

    const gotoPrevious = () => setCurrImg((prev) => Math.max(prev - 1, 0));
    const gotoNext = () => setCurrImg((prev) => prev + 1);
    const closeViewer = () => setViewerIsOpen(false);

    // Example: open viewer when clicking on an image thumbnail
    const handleImageClick = (index: number) => {
        setCurrImg(index);
        setViewerIsOpen(true);
    };

    useEffect(() => {
        fetch(makeCDNImagesUrl('media.json'))
            .then((res) => res.json())
            .then((data: string[]) => {
                setImages(data.map(name => `${makeCDNImagesUrl(name)}`));
            })
    }, []);

    return (
        <>
            <NextSeoWrapper
                title="mediaPost"
                url={getCanonicalUrl(lang, path)}
                languageAlternates={getLanguageAlternates(path)}
            />
            <PageContainer>
                
                    <div>
                        <div className={styles.container}>
                            {images.map((src, index) => (
                                <div key={index} className={styles.imageWrapper} style={{marginBottom: '10px'}}>
                                    <Image
                                        src={src}
                                        alt={`Image ${index + 1}`}
                                        width={300}
                                        height={200}
                                        layout="responsive"
                                        onClick={() => handleImageClick(index)}
                                        className={styles.thumbnail}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                
             
                <ImgsViewer
                    imgs={images.map(src => ({ src }))}
                    currImg={currImg}
                    isOpen={viewerIsOpen}
                    onClickPrev={gotoPrevious}
                    onClickNext={gotoNext}
                    onClose={closeViewer}
                    // showCloseBtn={false}
                    backdropCloseable = {true}
                    onClickThumbnail={(index) => setCurrImg(index)}
                    showThumbnails
                />
            </PageContainer>
        </>
    );
};

export default MediaPage;
